import { gql } from '@apollo/client';
import { Product } from '@interfaces';

export const LastWhimProductsQuery = () => gql`
  query LastWhimProducts($params: LastWhimProductsParams!) {
    lastWhimProducts(params: $params) {
      id
      laboratory
      price
      activePrinciple
      lastWhimType
      lastWhimIndex
      availability {
        status
        discountStock
        stock
      }
      discount {
        price
        type
        stockRestriction
        dateRestriction
        listPrice
      }
      quantity
      concentration
      imagesUrl
      name
      slug
      thumbnailUrl
      unit
      format
      uuid
      isCheapestActivePrinciple
    }
  }
`;

export type LastWhimProductsQueryResponse = {
  lastWhimProducts: Product[];
};

export type LastWhimProductsParams = {
  params: {
    orderUuid: string;
  };
};
